"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _createDeferred = _interopRequireDefault(require("./createDeferred"));

var _createErrorEvent = _interopRequireDefault(require("./createErrorEvent"));

function speakUtterance(ponyfill, utterance, startCallback) {
  var speechSynthesis, startDeferred, errorDeferred, endDeferred, startEvent, finishedSpeaking, endPromise, endEvent;
  return _regenerator["default"].async(function speakUtterance$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          speechSynthesis = ponyfill.speechSynthesis;
          startDeferred = (0, _createDeferred["default"])();
          errorDeferred = (0, _createDeferred["default"])();
          endDeferred = (0, _createDeferred["default"])();
          utterance.addEventListener('end', endDeferred.resolve);
          utterance.addEventListener('error', errorDeferred.resolve);
          utterance.addEventListener('start', startDeferred.resolve); // if (speechSynthesis.speaking) {
          //   console.warn(`ASSERTION: speechSynthesis.speaking should not be truthy before we call speak`);
          // }

          speechSynthesis.speak(utterance);
          _context2.next = 10;
          return _regenerator["default"].awrap(Promise.race([errorDeferred.promise, startDeferred.promise]));

        case 10:
          startEvent = _context2.sent;

          if (!(startEvent.type === 'error')) {
            _context2.next = 13;
            break;
          }

          throw startEvent.error;

        case 13:
          endPromise = Promise.race([errorDeferred.promise, endDeferred.promise]);
          startCallback && startCallback(function _callee() {
            return _regenerator["default"].async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (finishedSpeaking) {
                      _context.next = 4;
                      break;
                    }

                    speechSynthesis.cancel();
                    _context.next = 4;
                    return _regenerator["default"].awrap(endPromise);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
          _context2.next = 17;
          return _regenerator["default"].awrap(endPromise);

        case 17:
          endEvent = _context2.sent;
          finishedSpeaking = true; // if (speechSynthesis.speaking) {
          //   console.warn(`ASSERTION: speechSynthesis.speaking should not be truthy after speak is stopped`);
          // }
          // console.debug(`ENDED: ${ utterance.text }`);

          if (!(endEvent.type === 'error')) {
            _context2.next = 21;
            break;
          }

          throw endEvent.error;

        case 21:
        case "end":
          return _context2.stop();
      }
    }
  });
}

var QueuedUtterance = /*#__PURE__*/function () {
  function QueuedUtterance(ponyfill, utterance, _ref) {
    var onEnd = _ref.onEnd,
        onError = _ref.onError,
        onStart = _ref.onStart;
    (0, _classCallCheck2["default"])(this, QueuedUtterance);
    this._cancelled = false;
    this._deferred = (0, _createDeferred["default"])();
    this._onEnd = onEnd;
    this._onError = onError;
    this._onStart = onStart;
    this._ponyfill = ponyfill;
    this._speaking = false;
    this._utterance = utterance;
    this.promise = this._deferred.promise;
  }

  (0, _createClass2["default"])(QueuedUtterance, [{
    key: "cancel",
    value: function cancel() {
      return _regenerator["default"].async(function cancel$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this._cancelled = true;
              _context3.t0 = this._cancel;

              if (!_context3.t0) {
                _context3.next = 5;
                break;
              }

              _context3.next = 5;
              return _regenerator["default"].awrap(this._cancel());

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "speak",
    value: function speak() {
      var _this = this;

      if (this._speaking) {
        console.warn("ASSERTION: QueuedUtterance is already speaking or has spoken.");
      }

      this._speaking = true;
      (function _callee2() {
        return _regenerator["default"].async(function _callee2$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this._cancelled) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('cancelled');

              case 2:
                _context4.next = 4;
                return _regenerator["default"].awrap(speakUtterance(_this._ponyfill, _this._utterance, function (cancel) {
                  if (_this._cancelled) {
                    cancel();
                    throw new Error('cancelled');
                  } else {
                    _this._cancel = cancel;
                    _this._onStart && _this._onStart(new Event('start'));
                  }
                }));

              case 4:
                if (!_this._cancelled) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('cancelled');

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        });
      })().then(function () {
        _this._onEnd && _this._onEnd(new Event('end'));

        _this._deferred.resolve();
      }, function (error) {
        _this._onError && _this._onError((0, _createErrorEvent["default"])(error));

        _this._deferred.reject(error);
      });
      return this.promise;
    }
  }]);
  return QueuedUtterance;
}();

exports["default"] = QueuedUtterance;